var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLocationMarker = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7143 14.3806L11.1785 17.9164C11.0239 18.0712 10.8402 18.194 10.6381 18.2778C10.436 18.3616 10.2194 18.4047 10.0006 18.4047C9.78179 18.4047 9.56515 18.3616 9.36303 18.2778C9.16092 18.194 8.9773 18.0712 8.82267 17.9164L5.286 14.3806C4.35368 13.4482 3.71878 12.2603 3.46157 10.9671C3.20437 9.67394 3.33641 8.33352 3.841 7.11536C4.3456 5.89721 5.20008 4.85604 6.2964 4.12351C7.39272 3.39098 8.68164 3 10.0002 3C11.3187 3 12.6076 3.39098 13.7039 4.12351C14.8003 4.85604 15.6547 5.89721 16.1593 7.11536C16.6639 8.33352 16.796 9.67394 16.5388 10.9671C16.2816 12.2603 15.6466 13.4482 14.7143 14.3806V14.3806Z",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7678 11.4343C12.2366 10.9654 12.5 10.3295 12.5 9.6665C12.5 9.00346 12.2366 8.36758 11.7678 7.89874C11.2989 7.4299 10.663 7.1665 10 7.1665C9.33696 7.1665 8.70107 7.4299 8.23223 7.89874C7.76339 8.36758 7.5 9.00346 7.5 9.6665C7.5 10.3295 7.76339 10.9654 8.23223 11.4343C8.70107 11.9031 9.33696 12.1665 10 12.1665C10.663 12.1665 11.2989 11.9031 11.7678 11.4343Z",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocationMarker, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location-marker.e744b6b6.svg";
export { ForwardRef as ReactComponent };